<!-- @if(this.loadingService.getLoading()){
<div class="cssload-container">
  <div>
    <img
      src="../../../assets/images/logos/loader-gif.svg"
      class="cssload-speeding-wheel"
    />
  </div>
</div>
} -->
<!-- *" -->
<div *ngIf="loadingService.loading$ | async" class="cssload-container">
  <div>
    <img
      src="../../../assets/images/logos/loader-gif.svg"
      class="cssload-speeding-wheel"
    />
  </div>
</div>
